import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { media_url } from '../../hooks/useBlog';
import './NewsHero.scss';

const NewsHero = ({ banners }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    pauseOnHover: true,
    beforeChange: (current, next) => setCurrentSlide(next),
    customPaging: (i) => (
      <div className="news-hero-dot">
        <span className="dot-progress"></span>
      </div>
    ),
    appendDots: dots => (
      <div>
        <ul className="news-hero-dots">{dots}</ul>
      </div>
    )
  };

  return (
    <div className="news-hero-section">
      <Slider {...sliderSettings} className="news-hero-slider">
      
        {banners.filter(b => b.enabled).map((banner, index) => (
          <div key={banner.id} className="news-hero-slide">
            <div 
              className="news-hero-image"
              style={{ backgroundImage: `url(${media_url(banner.image)})` }}
            >
              <div className="news-hero-overlay"></div>
              <div className="container-fluid">
                <div className="news-hero-content">
                  {banner.category && (
                    <span className="news-hero-category">
                      {typeof banner.category === 'object' ? banner.category.name : banner.category}
                    </span>
                  )}
                  {banner.title && (
                    <h1 className="news-hero-title">{banner.title}</h1>
                  )}
                  {banner.excerpt && (
                    <p className="news-hero-excerpt">{banner.excerpt}</p>
                  )}
                  {banner.link && (
                    <a 
                      href={banner.link} 
                      className="news-hero-btn"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Leer más
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M7.5 5l5 5-5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default NewsHero;
